import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { AuditLogEntry } from '@/types/api';

export const AUDIT_KEY = ['audit'] as const;

// GET /api/audit is paginated server-side; the first page (data array) is enough for
// the Logg view at MVP — pagination UI is post-MVP.
export function useAuditLog() {
  return useQuery({
    queryKey: AUDIT_KEY,
    queryFn: async () => (await api.get<{ data: AuditLogEntry[] }>('/audit')).data,
  });
}
